export const RESIZE_EVENT_SLUG = 'bz-widget-event-resize';

export const ALLOWED_ORIGINS = ['http://local.benzinga.com:3000', 'https://benzinga.com', 'https://www.benzinga.com'];

export interface ResizeEventData {
  width: string;
  height: string;
}

export const sendResizeEvent = (width: string | number, height: string | number, widgetId: string): void => {
  dispatchEvent({
    name: RESIZE_EVENT_SLUG,
    value: {
      height: formatResizeValue(height),
      width: formatResizeValue(width),
    },
    widget_id: widgetId,
  });
};

export const dispatchEvent = (message: any): void => {
  window?.top?.postMessage(message, '*');
};

const formatResizeValue = (value: string | number): number => {
  return Math.ceil(Number(value));
};
